module.exports = __webpack_public_path__ + "static/img/apex.d60973e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/apex.svg
// module id = WgVP
// module chunks = 35